var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cabinet",class:{
        'cabinet-supplier': _vm.isSupplier,
        'cabinet-adaptive': _vm.isRetailer,
        'cabinet-supplier--bg-gray': _vm.isCabinetBgGray,
        'cabinet-full': _vm.isFullPage
    }},[_c(_vm.cabinetNav,{tag:"component"}),_c('div',{staticClass:"cabinet-content",class:{ full: _vm.isFullPage, product: _vm.isProductPage }},[_c('vue-progress-bar'),_vm._t("default"),_c('cabinet-footer')],2),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }